import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { Grid, FormControlLabel, Switch } from '@mui/material';
import { useFormContext, Controller } from 'react-hook-form';
import FormSelect from '../../../../Components/Form/FormSelect';

const LeadDetailsPage = function LeadDetailsPage({
  leadOriginsOptions = [],
  errors, //if there are errors, the object containing fields keyNames and their error value
  data, //data at opening dialog (backend data)
  formData, //data inserted in the form
  edit,
}) {
  const intl = useIntl();
  const { reset, control } = useFormContext();

  useEffect(() => {
    reset({
      ...formData,
      ...data,
    });
  }, [data, formData]);

  return (
    <Grid container spacing={2} sx={{ width: '100%' }}>
      <Grid size={{ md: 4, sm: 6, xs: 12 }}>
        <FormSelect
          required
          error={errors?.leadOriginId}
          name="leadOriginId"
          label={intl.messages.LEAD_ORIGIN}
          options={leadOriginsOptions}
          defaultValue={leadOriginsOptions[0]?.value}
        />
      </Grid>

      <Grid size={{ md: 4, sm: 6, xs: 12 }}>
        <Controller
          name="leadStatus"
          control={control}
          render={({ field }) => {
            const statusLabel = field.value
              ? intl.messages.ACTIVE
              : intl.messages.INACTIVE;

            return (
              <FormControlLabel
                control={
                  <Switch {...field} checked={!!field.value} color="primary" />
                }
                label={statusLabel}
              />
            );
          }}
        />
      </Grid>
      {edit && (
        <Grid size={{ md: 4, sm: 6, xs: 12 }}>
          <Controller
            name="active"
            control={control}
            render={({ field }) => {
              const statusLabel = field.value
                ? intl.messages.ACTIVE
                : intl.messages.INACTIVE;

              return (
                <FormControlLabel
                  control={
                    <Switch
                      {...field}
                      checked={!!field.value}
                      color="primary"
                    />
                  }
                  label={`${intl.messages.LEAD_STATUS} ${statusLabel}`}
                />
              );
            }}
          />
        </Grid>
      )}
    </Grid>
  );
};

LeadDetailsPage.propTypes = {
  errors: PropTypes.object,
  data: PropTypes.object,
  formData: PropTypes.object,
  edit: PropTypes.bool,
  leadOriginsOptions: PropTypes.array,
};

export default LeadDetailsPage;
